<template>
  <div>
    <TableWithEndlessScroll
      :class="$style.osReleaseTable"
      :columns="columns"
      :moreToLoad="false"
      :tableData="tableData"
    >
      <template v-slot:emptyMessage>
        <p>
          Release train information is not available right now. Please try again later.
        </p>
      </template>
    </TableWithEndlessScroll>
  </div>
</template>

<script>
import DateUtil from 'client/util/DateUtil';
import TableWithEndlessScroll from 'client/components/Tables/TableWithEndlessScroll';
import pluralize from 'pluralize';

export default {
  name: 'OsReleasePatch',

  components: { TableWithEndlessScroll },

  props: {
    osName: {
      type: String,
      required: true,
    },
    osReleases: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    buildText() {
      return this.osName === 'Windows' ? 'Latest Build' : 'Latest Version';
    },

    columns() {
      return [
        { dataField: 'version', name: 'Name' },
        { dataField: 'build', name: this.buildText },
        { dataField: 'releaseTimestamp', name: 'Released' },
      ];
    },

    tableData() {
      if (!this.osReleases) return [];
      return this.osReleases.map((os) => {
        const numDays = DateUtil.daysAfter(os.releaseTimestamp);
        const timestampText = `${numDays} ${pluralize('day', numDays)} ago`;
        return (os.operatingSystem.includes('Windows')
          ? {
            build: `${os.version}.${os.build}`,
            releaseTimestamp: timestampText,
            version: `${os.operatingSystem} version ${os.name}`,
          }
          : {
            build: os.version + ((os.build.trim() !== '') ? ` (${os.build})` : ''),
            releaseTimestamp: timestampText,
            version: `${os.operatingSystem} ${os.name}`,
          });
      });
    },
  },
};
</script>
<style module>
.osReleaseTable {
  border: 0 !important;
  box-shadow: none !important;
  margin-top: 10px;
  max-height: 285px;
}

.osReleaseTable table {
  table-layout: fixed;
}

.osReleaseTable table thead th {
  padding: 10px 8px 8px !important;
}

.osReleaseTable table tbody tr {
  height: 32px;
}
</style>
